export default __webpack_public_path__ + "static/media/closed-padlock.3638aace.svg";